import { ModulesWithAvailableActivityList } from "src/app/business/available-activities/available-activities.component";
import { ExternalSettings } from "../external-settings/external-settings.interface";
import { InternalSettings } from "../internal-settings/internal-settings.interface";
import { logger } from "../logging/logging.service";
import { SidebarActivityType } from "../../components/sidebar/sidebar";

export enum MenuType {
  TOP = 'top',
  LEFT = 'left'
}

export interface PAActivityOptions {
  checkOnePermission?: boolean;
  isModuleEnabled?: boolean;
  permissions?: number[];
  checkFunction?: (is: InternalSettings, es: ExternalSettings) => boolean;
  subUrls?: string[];
  type?: SidebarActivityType;
}

export class PAActivity {
  public checkOnePermission: boolean;
  permissions: number[] = [];
  isModuleEnabled?: boolean;
  checkFunction?: (is: InternalSettings, es: ExternalSettings) => boolean;
  subUrls!: string[];
  type?: SidebarActivityType;

  constructor(public name: string, public label: string, public path: string, public index: number, options: PAActivityOptions = {}) {
    this.checkOnePermission = options.checkOnePermission || false;
    this.permissions = options.permissions || [];
    this.isModuleEnabled = options.isModuleEnabled;
    this.checkFunction = options.checkFunction;
    this.subUrls = options.subUrls || [];
    this.type = options.type || SidebarActivityType.DEFAULT;
  }
}

export class PAGroup {

  activities: PAActivity[] = [];
  permissions: number[] = [];
  isModuleEnabled?: boolean;
  iconPath!: string;
  params!: string | number | ModulesWithAvailableActivityList;

  constructor(
    public name: string,
    public title: string,
    public path: string,
    public index: number,
    public checkOnePermission: boolean = false
  ) { }

  public setActivities(avtivities: PAActivity[]): PAGroup {
    this.activities = avtivities;
    return this;
  }

  public setPermissions(value: number[]): PAGroup {
    this.permissions = value;
    return this;
  }

  public setIsModuleEnabled(value: boolean): PAGroup {
    this.isModuleEnabled = value;
    return this;
  }

  public setIconPath(value: string): PAGroup {
    this.iconPath = value;
    return this;
  }

  public setParams(value: string | number | ModulesWithAvailableActivityList): PAGroup {
    this.params = value;
    return this;
  }

  public findActivity(name: string): PAActivity | undefined {
    let activity: PAActivity | undefined = this.activities.find(
      (activity: PAActivity) => activity.name === name
    );
    return activity;
  }

  public removeActivity(name: string) {
    if (this.activities) {
      this.activities = this.activities.filter((b: PAActivity) => { return b.name != name });
    }
  }

  public replaceActivity(brick: PAActivity) {
    if (this.activities) {
      let name = brick.name;
      let index = this.activities.findIndex((b: PAActivity) => { return b.name == name });
      if (index != -1) {
        this.activities[index] = brick;
      }
    }
  }

  public addActivity(activity: PAActivity, index: number = -1) {
    if (index == -1) {
      index = this.activities.length; // add to the end
    }
    this.activities.splice(index, 0, activity);
    this.reOrderActivities();
  }

  public reOrderActivities() {
    for (let i = 0; i < this.activities.length; i++) {
      this.activities[i].index = (i + 1);
    }
  }
}

export class PASection {

  constructor(public name: string, public title: string, public index: number, public groups: PAGroup[]) { }

  public addGroup(group: PAGroup, index: number = -1) {
    if (index == -1) {
      index = this.groups.length; // add to the end
    }
    this.groups.splice(index, 0, group);
    this.reOrderGroups();
  }

  public reOrderGroups() {
    for (let i = 0; i < this.groups.length; i++) {
      this.groups[i].index = (i + 1);
    }
  }

  public findGroup(name: string) {
    let group: PAGroup | undefined = this.groups.find(
      (group: PAGroup) => group.name === name
    );
    return group;
  }
}

export class PASector extends PASection {
  constructor(public override name: string, public override index: number, public override groups: PAGroup[] = []) {
    super(name, name, index, groups);
  }
}

export class PAMenuDesktop {

  public sections?: Map<string, PASection>;

  constructor(public name: string) { }

  setSections(sections: Map<string, PASection>) {
    this.sections = sections;
    return this;
  }

}

export class PAMenuMobile {

  private sector_A!: PASector;
  private sector_B!: PASector;
  static SECTOR_A = 'sector_A';
  static SECTOR_B = 'sector_B';

  constructor(public name: string) { }

  setSector(sector: PASector) {
    switch (sector.name) {
      case PAMenuMobile.SECTOR_A:
        this.sector_A = sector;
        break;
      case PAMenuMobile.SECTOR_B:
        this.sector_B = sector;
        break;
    }
    return this;
  }

  getSectorGroup(name: string) {
    switch (name) {
      case PAMenuMobile.SECTOR_A:
        return this.sector_A.groups;
      case PAMenuMobile.SECTOR_B:
        return this.sector_B.groups;
    }
    return null;
  }

  getSubMenu(groupName: string) {
    let subMenu: PAActivity[] = [];

    let tmpMenu = [...this.sector_A.groups, ...this.sector_B.groups];
    for (let i = 0; i < tmpMenu.length; i++) {
      let group = tmpMenu[i];
      if (group.name === groupName) {
        subMenu = group.activities;
        return subMenu;
      }
    }
    logger.error(`Unable to find groups with name: ${groupName}`);
    return [];
  }



}